module.exports = __webpack_public_path__ + "img/advantages-of-ocr.ded8c954.png";